/* *
 * asyncRequest is a place where we can centralise talking to our server.
 * error handling, data processing, and even the functions which deals with the server
 * can be centralised here.
 *
 * For instance we are initially using axios to talk to the server api, but should be decide to
 * use a different ajax lib we can relplace it one and everything should work.
 * */
import axios from "axios";
import store from "./../store/index.js";
import router from "./../router.js";

export default {
    M_SUCCESS: 1 << 0, //Enable success messages
    M_FAIL: 1 << 2, //Enable fail messages

    /* *
     *  ServerAPI makes a request to the database and on success calls a given callback.
     *
     *  method              : A string expected, the string has to be one of the following post, put, get, delete
     *  api                 : Is basically the api call to the server minus the url host information. SHOULD BEGIN WITH /
     *  onSuccessCallback   : Callbacks have to be in the form callback(data)  where data corresponds to the data we recieved from the database.
     *  onFailCallback      : call when something fails
     *  postData            : post data.
     *  flags               : Tells us which messages we should handle. If you only want success messages printed M_SUCCESS for fails only M_FAIL
     *                        for both   M_SUCCESS|M_FAIL
     *  customSuccessMessage: if its empty ServerApi(..) will use the success message recieved from the server as the params used in the success popup
     *                        else, it will use this message passed as the successpopup 200 and 201 will be considered as suceess
     *  customErrorMessage  : same as onHTTPSuccess but for errors.
     *                        400(bad-request),401(unauthorized),404,409(conflict), 500(internal),
     *                        AND >500 will all be considered as serverside errors and will promt a hard js alart
     *
     *  beforeAfterCallback : a function that will be called before execution of the axios call
     *                        the function will be called once again on success or fail.
     *                        usefull if you are trying to toggle a flag of some sort before and after calling :D
     *  progressBarObj
     *
     *   of course this wrapper wont satisfy everything, for very specialised snowflake situations you could use an ajax lib directly, but it is NOT ADVISED!
     *   its better to create a new function to handle the special case.
     *
     *   to make copy pasting easy :D
     *
        {
            method              :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            api                 :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            onSuccessCallback   :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            onFailCallback      :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            postData            :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            flags               :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            customSuccessMessage:XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            customErrorMessage  :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
            beforeAfterCallback :XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
        }
     *
     *
     *
     * */
    ServerAPI({
        method,
        api,
        onSuccessCallback,
        onFailCallback,
        postData,
        flags,
        customSuccessMessage,
        customErrorMessage,
        beforeAfterCallback,
        progressBarObj
    }) {
        if (progressBarObj) {
            progressBarObj.set(0);
        }

        if (typeof beforeAfterCallback == "function") {
            beforeAfterCallback();
        }

        var that = this;

        axios({
            method: method,
            url: api,
            data: postData,
            withCredentials: true //indicates whether or not cross-site Access-Control requests should be made or not, should be enabled when developing
        })
            .then(function(response) {
                if (progressBarObj) {
                    progressBarObj.finish();
                }
                if (typeof beforeAfterCallback == "function") {
                    beforeAfterCallback(response.data);
                }
                that.onHTTPSuccess(response, flags, customSuccessMessage);
                return response;
            })
            .then(function(responseData) {
                if (onSuccessCallback != "") {
                    //Sometimes we can call without callbacks
                    onSuccessCallback(responseData.data);
                }
                return responseData;
            })
            .catch(function(err_response) {
                //eslint-disable-next-line
                console.log("M::::", method, "\nAPI::", api, "\nR::::", err_response);
                if (onFailCallback && onFailCallback != "") {
                    onFailCallback(err_response);
                }
                if (progressBarObj) {
                    progressBarObj.fail();
                }
                that.onHTTPFail(err_response.response, flags, customErrorMessage);

                return err_response;
            })
            .then(function(response) {
                if (typeof beforeAfterCallback == "function") {
                    beforeAfterCallback(response.response.data);
                }
            });

        if (progressBarObj) {
            progressBarObj.finish();
        }
    },

    //This function helps us deal with the custom messages and overiding them when the http request was a success
    onHTTPSuccess(serverResponse, messageFlags, msgOverride) {
        if (!(messageFlags & this.M_SUCCESS)) {
            //Dont do anything if M_SUCCESS flag is not set
            return;
        }

        var serverMessage = "";
        try {
            serverMessage = serverResponse.data.Message;
        } catch (e) {
            //do Nothing.
        }

        if (!msgOverride) {
            // For 200 we do not expect any messages from the server. 200 just denotes the presense of a successfull get request most times.
            switch (serverResponse.status) {
                case 200:
                    msgOverride = serverMessage == "" ? " Success! Everything was A-OK! " : serverMessage;
                    break;

                case 201:
                    msgOverride = serverMessage == "" ? " Success! " : serverMessage;
                    break;
                default:
                    msgOverride = "Success. No idea why. Please report this incident to the admin.";
            }
        }
        store.commit("notifications/changeNotificationModalState", {
            message: msgOverride,
            type: "Success"
        });
    },

    onHTTPFail(serverResponse, messageFlags, msgOverride) {
        if (!(messageFlags & this.M_FAIL)) {
            //this is not supposed to happen.
            //eslint-disable-next-line
            console.log("ERROR, but flags told me not give feedback to user");
            return; //Dont do anything if M_FAIL flag is not set
        }

        var serverMessage = "";
        try {
            serverMessage = serverResponse.data.Message;
        } catch (e) {
            //do Nothing.
        }

        if (!msgOverride) {
            switch (serverResponse.status) {
                case 400: //Bad request normally this is when the user sends crap to the user. basically validation error.
                    msgOverride = serverMessage == "" ? "Please check the data you have entered!" : serverMessage;
                    break;
                case 401: //Unauthorised, we need to check the user"s login status and redirect him
                    msgOverride = serverMessage == "" ? " Unrecognised login. Please login again. " : serverMessage;
                    router.push("/login/");
                    break;
                case 403: //Forbidden, says the user is logged in but he has no access to this resource
                    msgOverride =
                        serverMessage == ""
                            ? " Sorry, your account does not have the required permission to do that. "
                            : serverMessage;
                    break;
                case 404: //404 not found, mostly ui dev side error. Or server changed the routes.
                    msgOverride = serverMessage == "" ? "Resource requested for was not found!" : serverMessage;
                    break;
                case 406: //406 not acceptable, mostly user error. The data sent to the server is basically malformed, ie SHIT :p
                    msgOverride =
                        serverMessage == ""
                            ? "The server refuses to accept the data you have just sent! Please check your data and try again."
                            : serverMessage;
                    break;
                case 409: //Conflict. When a user tries to create a resource that is unique and its already created on the server.
                    msgOverride =
                        serverMessage == "" ? "Resource you tried to create is already on the server." : serverMessage;
                    break;
                case 500: //internal error, server side dev error.
                    msgOverride =
                        serverMessage == ""
                            ? "Something is wrong at the server end. Please let the admin know of this error."
                            : serverMessage;
                    break;
                default:
            }
        }
        store.commit("notifications/changeNotificationModalState", {
            message: msgOverride,
            type: "Error"
        });
    }
};
